<div class="ant-layout-sider-children">
  <ng-content></ng-content>
</div>
<span class="ant-layout-sider-zero-width-trigger" *ngIf="isZeroTrigger" (click)="toggleCollapse()">
  <ng-template [ngTemplateOutlet]="nzZeroTrigger || zeroTrigger"></ng-template>
</span>
<div class="ant-layout-sider-trigger"
  *ngIf="isSiderTrigger"
  (click)="toggleCollapse()"
  [style.width]="widthSetting">
  <ng-template [ngTemplateOutlet]="nzTrigger"></ng-template>
</div>
<ng-template #defaultTrigger>
  <i nz-icon [nzType]="nzCollapsed ? 'right' : 'left'" *ngIf="!nzReverseArrow"></i>
  <i nz-icon [nzType]="nzCollapsed ? 'left' : 'right'" *ngIf="nzReverseArrow"></i>
</ng-template>
<ng-template #zeroTrigger>
  <i nz-icon nzType="bars"></i>
</ng-template>